import type { AppGroup } from '@/types';
import appolloAppIcon from '../../assets/app-demo-appollo.png';
import voyagerAppIcon from '../../assets/app-demo-voyager.png';

export const appGroupsMock: AppGroup[] = [
    {
        id: '123456789',
        name: 'Appollo',
        appIds: ['appollo-ios', 'appollo-android', 'appollo-react-native-ota'],
        appGroupImageUrl: appolloAppIcon,
        useAppImage: false,
    },
    {
        id: '123456790',
        name: 'Gemini (Cross-platform)',
        appIds: ['gemini'],
        appGroupImageUrl: 'https://runway-img.s3.us-east-2.amazonaws.com/app-demo-gemini.png',
        useAppImage: false,
    },
    {
        id: '123456791',
        name: 'Mercury (White-label)',
        appIds: ['mercury'],
        appGroupImageUrl: 'https://runway-img.s3.us-east-2.amazonaws.com/app-demo-launch.png',
        useAppImage: false,
    },
    {
        id: '123456792',
        name: 'Voyager',
        appIds: ['voyager'],
        appGroupImageUrl: voyagerAppIcon,
        useAppImage: false,
    },
];
